import React from "react";
import { connect } from "react-redux";

import * as actions from "../actions/actions";

import FortMemberHeader from "./fort-member-header";
import InvoiceList from "./invoice-list";
import InvoiceDetail from "./invoice-edit";
let Loading = require("./loading");

class FortCustomerInfoWrapper extends React.Component {
    constructor(props) {
        super(props);

        if (!props.creator) {
            this.props.fetchCreator(props.creatorId);
        }

        this.state = {};
    }

    render() {
        if (this.props.creator) {
            let invoiceList = this.renderInvoiceList();
            let invoiceDetail = this.renderInvoiceDetail();

            return (
                <span>
                    <FortMemberHeader />
                    <div className="container new-form" style={{ marginTop: "20px" }}>
                        {invoiceList}
                        {invoiceDetail}
                    </div>
                </span>
            );
        } else {
            return <Loading />;
        }
    }

    renderInvoiceDetail() {
        let invoiceDetail;

        if (this.props.chargeId) {
            invoiceDetail = (
                <InvoiceDetail creator={this.props.creator} chargeId={this.props.chargeId} />
            );
        }

        return invoiceDetail;
    }

    renderInvoiceList() {
        let invoiceList;

        if (!this.props.chargeId) {
            invoiceList = <InvoiceList creator={this.props.creator} />;
        }

        return invoiceList;
    }
}

function mapStateToProps(state, ownProps) {
    let creator;

    if (state.creator.keys) {
        creator = state.creator[state.creator.keys[0]];
    }

    return { creator };
}

module.exports = connect(mapStateToProps, {
    fetchCreator: actions.fetchCreator
})(FortCustomerInfoWrapper);
